"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { revalidatePathAction } from "@/actions/revalidate-path-action";
import { useGetServiceQuota } from "@/services/restriction/get-service-quota";

export const ServiceQuotaTrigger = () => {
  const pathname = usePathname();
  const { data } = useGetServiceQuota();

  useEffect(() => {
    if (data?.blocked) {
      revalidatePathAction(pathname);
    }
  }, [pathname, data?.blocked]);

  return null;
};
